import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import branch from 'branch-sdk';

import { handleBranchData } from '../components/Main/utils';

import { captureException } from '../sentryInit';

const useBranchData = () => {
  const history = useHistory();

  const callback = (err, data) => {
    if (err) {
      captureException(err);
    }

    data?.data && handleBranchData(data?.data_parsed, history);
  };

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    branch.data(callback);
  }, []);

  return null;
};

export default useBranchData;
